export default "__VITE_ASSET__CLDijR5b__"